import React from "react";
import "./T1.css";

export default function T1({
  name,
  title,
  subtitle,
  subtitle_2,
  description,
  description_2,
  info,
  info_2,
  image_url,
  image_url_2,
  // novos campos
  link_url,
  link_url_2,
  link_tag,
  link_tag_2,
}) {
  const hasOneImage = Boolean(image_url) && !Boolean(image_url_2);
  const stackClass = hasOneImage ? "has-one" : "has-two";

  const links = [
    { url: link_url, tag: link_tag },
    { url: link_url_2, tag: link_tag_2 },
  ].filter((l) => !!l.url);

  return (
    <section className="t1x-root">
      {/* retângulos decorativos */}
      <div className="t1x-deco t1x-deco--tl" />
      <div className="t1x-deco t1x-deco--br" />
      <div className="t1x-deco t1x-deco--mid" />

      <div className="t1x-container">
        <div className="t1x-left">
          {/* logo menor no canto superior esquerdo */}
          <div className="t1x-brand-small">
            <img src="/brand/brand-2.svg" alt="brand" />
          </div>

          {/* faixa de destaque do título */}
          {name && <p className="t1x-overline">{name}</p>}
          {title && <h1 className="t1x-title">{title}</h1>}

          {subtitle && <p className="t1x-subtitle">{subtitle}</p>}
          {subtitle_2 && <p className="t1x-subtitle2">{subtitle_2}</p>}

          {description && <p className="t1x-body">{description}</p>}
          {description_2 && <p className="t1x-body">{description_2}</p>}

          {/* META: links (primeiro) + infos (depois) no mesmo bloco/posição */}
          {(links.length > 0 || info || info_2) && (
            <div className="t1x-meta">
              {links.length > 0 && (
                <div className="t1x-links">
                  {links.map((l, i) => (
                    <a
                      key={`link-${i}`}
                      className="t1x-linkpill"
                      href={l.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={l.url}
                    >
                      <span className="t1x-link-icon" aria-hidden>
                        🔗
                      </span>
                      <span>{l.tag?.trim() || l.url}</span>
                    </a>
                  ))}
                </div>
              )}

              {(info || info_2) && (
                <div className="t1x-infos">
                  {info && <span className="t1x-chip">{info}</span>}
                  {info_2 && <span className="t1x-chip">{info_2}</span>}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="t1x-right">
          <div className={`t1x-images-stack ${stackClass}`}>
            {image_url && (
              <figure className="t1x-media t1x-media--main">
                <img src={image_url} alt="" className="t1x-img" />
              </figure>
            )}
            {image_url_2 && (
              <figure className="t1x-media t1x-media--sec">
                <img src={image_url_2} alt="" className="t1x-img" />
              </figure>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
